import { HOMESCREEN_PATH } from "./app";

export const CUSTOMER_ROUTE_SEGMENTS = {
  root: "customer",
  customerId: ":customerId",
  emissionFactorsLibrary: "emission-factors-library",
} as const;

export const buildCustomerPath = (customerId: string): string => `/${CUSTOMER_ROUTE_SEGMENTS.root}/${customerId}`;

export const buildEmissionFactorsLibraryPath = (customerId: string): string =>
  `${buildCustomerPath(customerId)}/${CUSTOMER_ROUTE_SEGMENTS.emissionFactorsLibrary}`;

export const getCustomerLandingPath = (customerId: string | undefined): string =>
  customerId === undefined ? HOMESCREEN_PATH : `${buildCustomerPath(customerId)}/`;
